import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { Box, IconButton, Link, Typography } from "@mui/material";

type Props = {
  title: string;
  name?: string;
  email?: string;
  phone?: string;
  onEdit: () => void;
};

export default function VendorContactBlock({ title, name, email, phone, onEdit }: Props) {
  const hasContact = Boolean(name || email || phone);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, letterSpacing: 0.6 }}>
          {title}
        </Typography>
        <IconButton
          component="span"
          size="small"
          onClick={onEdit}
          aria-label={hasContact ? `Edit ${title.toLowerCase()}` : `Add ${title.toLowerCase()}`}
          sx={{ p: 0.25 }}
        >
          {hasContact ? <EditOutlinedIcon sx={{ fontSize: 16 }} /> : <PersonAddAlt1Icon sx={{ fontSize: 16 }} />}
        </IconButton>
      </Box>
      {hasContact ? (
        <>
          <Typography fontWeight={600} sx={{ fontSize: 14 }}>
            {name || "—"}
          </Typography>
          {email ? (
            <Link href={`mailto:${email}`} sx={{ fontSize: 13, display: "block" }}>
              {email}
            </Link>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
              —
            </Typography>
          )}
          {phone && (
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
              {phone}
            </Typography>
          )}
        </>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: 13 }}>
          No contact added
        </Typography>
      )}
    </Box>
  );
}
